import { useState } from 'react';
import { Scan, Receipt } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import TabNavigation from '../components/TabNavigation';
import AnimatedContent from '../components/AnimatedContent';
import ScanTab from '../components/scan/ScanTab';
import ReceiptsListTab from '../components/scan/ReceiptsListTab';

function ScanReceiptPage() {
  const [activeTab, setActiveTab] = useState('scan');
  const [direction, setDirection] = useState('forward');

  const tabs = [
    {
      id: 'scan',
      label: 'Scanner',
      icon: Scan
    },
    {
      id: 'list',
      label: 'Liste des frais',
      icon: Receipt
    }
  ];

  const handleTabChange = (newTab) => {
    // Déterminer la direction du défilement
    const currentIndex = tabs.findIndex(t => t.id === activeTab);
    const newIndex = tabs.findIndex(t => t.id === newTab);
    setDirection(newIndex > currentIndex ? 'forward' : 'backward');
    setActiveTab(newTab);
  };

  const getTabStyle = (tabId) => {
    const isActive = activeTab === tabId;

    if (!isActive) {
      return { display: 'none' };
    }

    return {
      animation: `slideIn${direction === 'forward' ? 'Left' : 'Right'} 0.3s ease-out`,
    };
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', fontFamily: '"Noto Sans", sans-serif' }}>
      <PageHeader
        icon={Scan}
        title="Scanner une facture ou ticket"
        subtitle="Importez vos factures et tickets pour extraction automatique des données"
      />

      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <AnimatedContent>
        <div style={{ position: 'relative', overflow: 'hidden' }}>
          <div style={getTabStyle('scan')}>
            <ScanTab />
          </div>
          <div style={getTabStyle('list')}>
            <ReceiptsListTab />
          </div>
        </div>
      </AnimatedContent>

      <style>{`
        @keyframes slideInLeft {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideInRight {
          from {
            transform: translateX(-100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}

export default ScanReceiptPage;
